module.exports = __webpack_public_path__ + "img/t_aboutvip.ae467601.png";